// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"f95dee10","310":"e805f7ef","321":"ce985c78","358":"b347dd30","462":"621a0089","605":"916111fe","653":"672039b7","680":"60f0a095"}[chunkId] + ".chunk.js";
};